import { render, staticRenderFns } from "./point-card.vue?vue&type=template&id=578203e6"
import script from "./point-card.vue?vue&type=script&lang=js"
export * from "./point-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports